import { Props_SnippetAccordion } from "./Accordion.props";
import SnippetLink from '../Shared/Link/Link';

const Accordion = (props: Props_SnippetAccordion) => {
    const { accordionTitle, repeatable_accordionRow } = props;

    const accordionTitleClass = accordionTitle.visibility?.value ? "" : "accessible-heading";

    return (
        <section className="snippet-accordion">
            <div className="snippet-accordion__container">
                {accordionTitle?.text?.value && <h2 className={`snippet-accordion__title ${accordionTitleClass}`}>
                    {accordionTitle.text.value}
                </h2>}

                <div className="snippet-accordion__row-container">
                    {repeatable_accordionRow.map((accordionRow, index) => {
                        const { linkText, linkHref, linkStyle, linkTarget, title, text } = accordionRow;

                        return (
                            <details
                                key={"accordion-row-" + index}
                                className="snippet-accordion__row"
                                name="accordion-row"
                            >
                                {accordionTitle && <summary className="snippet-accordion__row-title">
                                    {title ? title.value : "Accordion Row " + (index + 1)}
                                </summary>}
                                <div className="snippet-accordion__content-container">
                                    {text && <p className="snippet-accordion__text">
                                        {text.value}
                                    </p>}
                                    {linkHref?.value && linkText?.value &&
                                        <SnippetLink
                                            linkStyles={linkStyle?.value}
                                            className="snippet-accordion__link"
                                            url={linkHref?.value}
                                            openInNewTab={!!linkTarget?.value}
                                            rel={linkTarget ? "noopener noreferrer" : undefined}
                                        >
                                            {linkText?.value}
                                        </SnippetLink>
                                    }
                                </div>
                            </details>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Accordion;
